import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./style.css";

// import required modules
import { Navigation, Pagination } from "swiper";
import ClickableImage from "../../../../components/ClickableImage";

const ProductSwiper = ({ images, className }) => {
  return (
    <div className={`product-images-swiper ${className || ""}`}>
      <Swiper
        className="product-swiper"
        slidesPerView={1}
        navigation={true}
        grabCursor={true}
        pagination={{
          clickable: true,
          type: "bullets",
        }}
        modules={[Navigation, Pagination]}
      >
        {images.map((url, index) => (
          <SwiperSlide key={index} className="product-swiper-slide">
            <div className="product-swiper-slide-image-container">
              <ClickableImage
                imageSrc={url}
                size={"lg"}
                imageClass={"product-swiper-image"}
                hideShadow={true}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ProductSwiper;
